export const SMS_ERROR_CODES = {
  MANUAL_DISABLED_SMS_CODE: 'manual_unsubscribed',
} as const;
